import { render } from "./InDel_Treatments.vue?vue&type=template&id=f7a5bf0e"
import script from "./InDel_Treatments.vue?vue&type=script&lang=js"
export * from "./InDel_Treatments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__